import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import MenuItem from "@material-ui/core/MenuItem";
import { Typography, useMediaQuery } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import clsx from "clsx";
import Colors from "../../constants/Colors";
import useTheme from "@material-ui/core/styles/useTheme";
import { fromJS } from "immutable";
import { getStateName, getStateAbbreviation } from "../../constants/States";

export default function StateSelect({
  primary,
  value,
  defaultColor,
  updateValue,
  rootStyle,
  selectMenuProps,
  selectClasses,
  menuItemClasses,
  iconColor,
  textColor,
  blueText,
  iOS,
  source = "clinic",
}) {
  const data = useStaticQuery(graphql`
    query {
      clinicStates: allDatoCmsClinic {
        nodes {
          state
        }
      }
      communityStates: allDatoCmsCommunityResource {
        nodes {
          state
        }
      }
    }
  `);
  const theme = useTheme();
  const smallBreakpoint = useMediaQuery(theme.breakpoints.down("xs"));
  const applyNative = smallBreakpoint || iOS;

  const rawStates = fromJS(
    source === "clinic" ? data.clinicStates.nodes : data.communityStates.nodes
  )
    .map(f => f.get("state"))
    .filter(Boolean);

  const uniqueStates = rawStates
    .map(getStateAbbreviation)
    .toSet()
    .toList()
    .sort();

  return (
    <div style={{ ...rootStyle }}>
      <Select
        native={applyNative}
        fullWidth
        disableUnderline
        onChange={e => updateValue(e.target.value)}
        MenuProps={selectMenuProps}
        classes={selectClasses}
        value={value}
        className={clsx("state-select-hook", blueText ? "state-select-bluetext" : null)}
        style={{ marginLeft: smallBreakpoint ? 0 : null }}
      >
        {!applyNative && (
          <MenuItem value="none">
            <Typography
              variant="h6"
              style={{
                marginBottom: "2px",
                fontFamily: "Lato, Verdana, sans-serif",
                fontWeight: "Bold",
                color: defaultColor || Colors.mineShaft,
                textTransform: "none",
              }}
            >
              Select your state
            </Typography>
          </MenuItem>
        )}

        {!applyNative &&
          uniqueStates.map(stateAbbr => (
            <MenuItem key={stateAbbr} value={stateAbbr} classes={menuItemClasses}>
              <Typography
                variant="h6"
                style={{
                  fontFamily: "Lato, Verdana, sans-serif",
                  fontWeight: "bold",
                  color: textColor || Colors.azure,
                  textTransform: "none",
                }}
              >
                {getStateName(stateAbbr)}
              </Typography>
            </MenuItem>
          ))}

        {applyNative && (
          <>
            <option value="none">Select your state</option>
            {uniqueStates.map(stateAbbr => (
              <option key={stateAbbr} value={stateAbbr}>
                {getStateName(stateAbbr)}
              </option>
            ))}
          </>
        )}
      </Select>
    </div>
  );
}
